
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"9.25","y":"45.25","width":"77.5","height":"27.5","rx":"7.75","fill":"currentColor","fill-opacity":".07","stroke":"currentColor","stroke-width":"2.5"}}),_c('rect',{attrs:{"x":"21","y":"55","width":"14","height":"8","rx":"2","fill":"currentColor","fill-opacity":".45"}}),_c('rect',{attrs:{"x":"41","y":"55","width":"14","height":"8","rx":"2","fill":"currentColor","fill-opacity":".45"}}),_c('rect',{attrs:{"x":"61","y":"55","width":"14","height":"8","rx":"2","fill":"currentColor","fill-opacity":".45"}}),_c('path',{attrs:{"d":"M48 45V34a7 7 0 017-7h12","stroke":"currentColor","stroke-width":"2.5","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"67.25","y":"20.25","width":"15.5","height":"13.5","rx":"3.25","fill":"currentColor","fill-opacity":".16","stroke":"currentColor","stroke-width":"2.5"}})])
          )
        }
      }
    